import { plotTool } from './plotTool';
import { buildingTool } from './buildingTool';
import { lineTool } from './lineTool';
import { markerTool } from './markerTool';
import { useDrawingTools } from './useDrawingTools';

export { plotTool, buildingTool, lineTool, markerTool, useDrawingTools };

// Коллекция инструментов
export const drawingTools = {
    'draw-plot': plotTool,
    'draw-building': buildingTool,
    'draw-line': lineTool,
    'draw-road': lineTool,
    'draw-railway': lineTool,
    'draw-boundary': lineTool,
    'draw-marker': markerTool,
};
